import type { ThemeColors } from '@sravni/cosago-react-library/lib/types';
import { parseThemePalette } from '@sravni/cosago-react-library/lib/utils';

import { DEFAULT_THEME, defaultPartnerThemePalette } from '../config/themePalette.config';

export const getThemeColors = (themePalette: string, partnerId: number | undefined | null): ThemeColors | null => {
  if (themePalette) {
    return parseThemePalette({ parseThemeStr: themePalette, defaultValue: DEFAULT_THEME });
  }
  if (typeof partnerId === 'number' && defaultPartnerThemePalette[partnerId]) {
    return defaultPartnerThemePalette[partnerId];
  }

  return null;
};
